module.exports = __webpack_public_path__ + "img/ry8.2b4de737.jpeg";